function defaultNetworkRequestCallback(networkRequestInfo) {
  return networkRequestInfo;
}
function isNetworkRequestCallback(value) {
  return typeof value === 'function';
}
export { defaultNetworkRequestCallback, isNetworkRequestCallback };